
export const CALL_API = process.env.REACT_APP_LINKAPI;
export const CALL_IMAGE = process.env.REACT_APP_CALL_IMAGE;
export const CALL_UPLOADS = process.env.REACT_APP_CALL_UPLOADS;
export const SITEKEY = process.env.REACT_APP_SITEKEY;
export const PSITEKEY = process.env.REACT_APP_PSITEKEY;
